import { APPS } from './meta';

const localSubdomainRegex = `local-(${APPS.join('|')})`;

export const localSubdomainToAppName = (subdomain: string) => {
  const [, app] = subdomain.match(localSubdomainRegex) || [];

  return app;
};
